<div class="ui-input" :class="styleAll">
  <input :type="type" :name="privateId" :id="privateId" :class="styleClass" :maxlength="maxlength"
    :placeholder="placeholderLocal" v-model="privateValue" :value="value" :disabled="isDisable" 
    :style="`height: ${height}px`" :min="min" 
    @keydown="onkeydown($event)"  @change="onkeyup($event)">
    <div  :class="{'erroSpan' : error}" v-if="error"> {{error}}</div>
</div>